import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useOrders } from '../contexts/OrderContext';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { TicketPrint } from '../components/TicketPrint';
import { ArrowLeft, MapPin, Phone, Package, CheckCircle } from 'lucide-react';
import { Order } from '../types';
export function ConfirmCollectionPage() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    orders,
    updateOrderStatus
  } = useOrders();
  const [order, setOrder] = useState<Order | null>(null);
  const [step, setStep] = useState<'DETAILS' | 'PRINT' | 'SUCCESS'>('DETAILS');
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    if (id) {
      const found = orders.find(o => o.id === id);
      setOrder(found || null);
    }
  }, [id, orders]);
  if (!order) {
    return <div className="text-center py-12" data-id="element-311">
        <p className="text-gray-500" data-id="element-312">Commande introuvable</p>
        <Button variant="ghost" onClick={() => navigate('/driver')} className="mt-4" data-id="element-313">
          Retour au tableau de bord
        </Button>
      </div>;
  }
  const handlePrintComplete = async () => {
    setIsSubmitting(true);
    try {
      await updateOrderStatus(order.id, 'COLLECTEE', 'Collecte confirmée par chauffeur');
      setStep('SUCCESS');
    } catch (error) {
      console.error('Failed to confirm collection', error);
      alert('Erreur lors de la confirmation');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (step === 'SUCCESS') {
    return <div className="max-w-md mx-auto text-center py-12 px-4" data-id="element-314">
        <div className="bg-green-100 text-green-600 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-315">
          <CheckCircle className="w-10 h-10" data-id="element-316" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-317">
          Collecte Confirmée !
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-318">
          Le statut de la commande a été mis à jour.
        </p>
        <Button onClick={() => navigate('/driver')} fullWidth data-id="element-319">
          Retour au tableau de bord
        </Button>
      </div>;
  }
  return <div className="max-w-2xl mx-auto space-y-6" data-id="element-320">
      <div className="flex items-center" data-id="element-321">
        <Button variant="ghost" onClick={() => navigate('/driver')} className="mr-2 pl-0" data-id="element-322">
          <ArrowLeft className="w-5 h-5" data-id="element-323" />
        </Button>
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-324">
          Confirmer la Collecte
        </h1>
      </div>

      <Card title="Détails de la commande" data-id="element-325">
        <div className="space-y-4" data-id="element-326">
          <div className="flex items-start" data-id="element-327">
            <div className="flex-shrink-0 mt-1" data-id="element-328">
              <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg" data-id="element-329">
                {order.clientName.charAt(0)}
              </div>
            </div>
            <div className="ml-4" data-id="element-330">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-331">
                {order.clientName}
              </h3>
              <div className="mt-1 flex items-center text-gray-500" data-id="element-332">
                <Phone className="w-4 h-4 mr-2" data-id="element-333" />
                {order.clientPhone}
              </div>
              <div className="mt-1 flex items-center text-gray-500" data-id="element-334">
                <MapPin className="w-4 h-4 mr-2" data-id="element-335" />
                {order.address}
              </div>
              <div className="mt-1 ml-6 text-sm text-gray-400" data-id="element-336">
                Zone: {order.zone}
              </div>
            </div>
          </div>

          <div className="border-t border-gray-100 pt-4 mt-4" data-id="element-337">
            <div className="flex items-center justify-between" data-id="element-338">
              <div className="flex items-center text-gray-700" data-id="element-339">
                <Package className="w-5 h-5 mr-2 text-gray-400" data-id="element-340" />
                <span className="font-medium" data-id="element-341">{order.type}</span>
              </div>
              <div className="text-lg font-bold" data-id="element-342">x {order.quantity}</div>
            </div>
            {order.notes && <div className="mt-2 bg-yellow-50 p-3 rounded text-sm text-yellow-800" data-id="element-343">
                Note: {order.notes}
              </div>}
          </div>
        </div>
      </Card>

      <Card title="Impression du Ticket" data-id="element-344">
        <div className="py-2" data-id="element-345">
          <p className="text-sm text-gray-500 mb-4" data-id="element-346">
            Veuillez imprimer le ticket pour valider la collecte. Cette étape
            est obligatoire.
          </p>
          <TicketPrint orderData={order} onPrintComplete={handlePrintComplete} data-id="element-347" />
        </div>
      </Card>
    </div>;
}